module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// F:/Projects/tfs/VS2015/SolventC/SolventCWebsite/Angular4.Website/src/assets/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.eot?v=4.7.0
// module chunks = styles